import(/* webpackMode: "eager", webpackExports: ["Mermaid"] */ "/vercel/path0/node_modules/@theguild/remark-mermaid/dist/mermaid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/inter-latin-wght-normal.woff2\",\"weight\":\"100 900\",\"style\":\"normal\"},{\"path\":\"./fonts/inter-latin-wght-italic.woff2\",\"weight\":\"100 900\",\"style\":\"italic\"}],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundLink"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/404/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Switchers"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/footer/switchers.js");
;
import(/* webpackMode: "eager", webpackExports: ["LastUpdated"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/last-updated.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/locale-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientNavbar"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/navbar/index.client.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/sidebar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/theme-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOC"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/components/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingAnchor"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/mdx-components/heading-anchor.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/mdx-components/wrapper.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","useConfig"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/stores/config.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeConfigProvider","useThemeConfig"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/stores/theme-config.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOCProvider","useTOC"] */ "/vercel/path0/node_modules/nextra-theme-docs/dist/stores/toc.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nextra-theme-docs/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["CloseBannerButton"] */ "/vercel/path0/node_modules/nextra/dist/client/components/banner/close-banner-button.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientBanner"] */ "/vercel/path0/node_modules/nextra/dist/client/components/banner/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/nextra/dist/client/components/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImageZoom"] */ "/vercel/path0/node_modules/nextra/dist/client/components/image-zoom.js");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/vercel/path0/node_modules/nextra/dist/client/components/search.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/vercel/path0/node_modules/nextra/dist/client/components/select.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkipNavLink"] */ "/vercel/path0/node_modules/nextra/dist/client/components/skip-nav/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","Tab"] */ "/vercel/path0/node_modules/nextra/dist/client/components/tabs/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["useCopy"] */ "/vercel/path0/node_modules/nextra/dist/client/hooks/use-copy.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFSRoute"] */ "/vercel/path0/node_modules/nextra/dist/client/hooks/use-fs-route.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHash"] */ "/vercel/path0/node_modules/nextra/dist/client/hooks/use-hash.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMounted"] */ "/vercel/path0/node_modules/nextra/dist/client/hooks/use-mounted.js");
;
import(/* webpackMode: "eager", webpackExports: ["Details"] */ "/vercel/path0/node_modules/nextra/dist/client/mdx-components/details.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyToClipboard"] */ "/vercel/path0/node_modules/nextra/dist/client/mdx-components/pre/copy-to-clipboard.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleWordWrapButton"] */ "/vercel/path0/node_modules/nextra/dist/client/mdx-components/pre/toggle-word-wrap-button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/3-v2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/4-v2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/5-v2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/image-1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/image-2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/screenshot-2025-05-19-165122.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/automation/supra-automation-network.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/claim-rewards-section.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/dvrf/supradvrf.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/dvrf/untitled-diagram-mermaid-chart-2025-08-25-191451.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/integration/network/evm/images/private-key-export.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/move/supra-move-ide.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/network/image-1-1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/oracles/horizontal-ticker.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/oracles/image-1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/oracles/image-2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/oracles/vertical-price-widget.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/add-iassets-to-starkey-wallet/add-custom-token-2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/add-iassets-to-starkey-wallet/add-custom-token-prepopulate.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/add-iassets-to-starkey-wallet/add-custom-token.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/add-iassets-to-starkey-wallet/manage-token.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/confirm-transaction-in-wallet.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/connect-your-ethereum-network.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/initiating-the-premint-iasset-bridge-transaction-supra.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/initiating-the-premint-iasset-bridge-transaction.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/minting-pre-minted-iassets.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/iasset-minting-flow/token-minting-and-fund-receipt.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/base-apy.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/calculateX.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/calculation-mehodology.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/capital-efficiency-coefficient.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/capital-efficiency-coefficient2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/delegation-metrics.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/delegation-per-pool.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/deposit-limits.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/iasset-lifecycle.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/reward-metrics-aggregrate.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/staking-rewards.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/stimulus-adjusted-apy.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/stimulus-reward-distribution-mechanism.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/stimulus-reward.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/stimulus-rewards.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/target-vs.-current.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/proof-of-efficient-liquidity-poel/key-concept/target-vs.-current2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/reward-summary-panel.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/1-png.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/2-png.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/3-png.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/bridge-flow-connect-wallet.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/bridge-transaction-detail.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/bridge-transaction-request.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/supranova/supra-bridge-service.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/withdrawable-rewards.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/workflow-diagram.webp");
;
import(/* webpackMode: "eager", webpackExports: ["DocsShell"] */ "/vercel/path0/src/components/DocsShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocsWrapper"] */ "/vercel/path0/src/components/DocsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqAccordion","FaqItem"] */ "/vercel/path0/src/components/FaqItem.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyToaster"] */ "/vercel/path0/src/components/LazyToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PagefindSearch"] */ "/vercel/path0/src/components/PagefindSearch/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/vercel/path0/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/VidyardPlayer/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/layout/BrandLogo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileActions"] */ "/vercel/path0/src/layout/Header/MobileActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchStateProvider"] */ "/vercel/path0/src/lib/search-state.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
